import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { StarIcon, ChevronDownIcon } from 'lucide-react';
const TESTIMONIALS = [{
  result: '-15 cm',
  quote: 'Me sentí más liviana en pocas semanas. Bajó la hinchazón de la tarde y dejé de llegar a la noche con antojos.',
  name: 'Carmen M.',
  age: '44 años',
  country: 'México'
}, {
  result: '-12 cm',
  quote: 'Volví a tener energía sin vivir a café y fuerza de voluntad. Noté cambios reales en la cintura.',
  name: 'Sofía R.',
  age: '39 años',
  country: 'Colombia'
}, {
  result: '-14 cm',
  quote: 'Necesitaba algo simple que pudiera sostener. Me desinflamé y volví a notar cambios reales en la ropa.',
  name: 'Ana L.',
  age: '47 años',
  country: 'Argentina'
}];
function TestimonialCard({
  t,
  index
}: {
  t: (typeof TESTIMONIALS)[number];
  index: number;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.2
  }} className="card-premium p-6 md:p-8 relative hover:border-gold/40 transition-colors duration-300 mt-4 md:mt-0" data-id="element-228">
      <div className="space-y-6" data-id="element-229">
        {/* Stars */}
        <div className="flex gap-1" data-id="element-230">
          {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-secondary fill-secondary" data-id="element-231" />)}
        </div>

        {/* Quote */}
        <p className="text-foreground/90 font-body font-medium italic text-base md:text-lg leading-relaxed" data-id="element-232">
          "{t.quote}"
        </p>

        {/* Author Info */}
        <div className="pt-4 border-t border-border/50" data-id="element-233">
          <p className="font-display font-bold text-lg text-gold-light" data-id="element-234">
            {t.name}
          </p>
          <p className="text-sm text-foreground/60 font-body mt-1" data-id="element-235">
            {t.age} • {t.country}
          </p>
        </div>
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  const [expanded, setExpanded] = useState(false);
  const visible = TESTIMONIALS.slice(0, 2);
  const hidden = TESTIMONIALS.slice(2);
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-236">
      <div className="max-w-[1400px] mx-auto space-y-16" data-id="element-237">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-238">
          <p className="text-secondary font-bold uppercase tracking-wider text-sm" data-id="element-239">
            Lo que cuentan mujeres que hicieron H.E.R.
          </p>
          <h2 className="text-4xl md:text-5xl font-display font-black" data-id="element-240">
            Resultados <span className="text-gradient-gold" data-id="element-241">Reales</span>
          </h2>

          {/* Rating social proof */}
          <div className="flex flex-col items-center gap-2 pt-2" data-id="element-242">
            <div className="flex items-center gap-1" role="img" aria-label="Calificación 4.9 de 5 estrellas" data-id="element-243">
              {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 text-secondary fill-secondary" data-id="element-244" />)}
            </div>
            <p className="font-body text-foreground/70 text-[15px] md:text-base" data-id="element-245">
              <span className="font-semibold text-gold-light" data-id="element-246">4.9/5</span>{' '}
              basado en mujeres que completaron H.E.R.
            </p>
          </div>
        </motion.div>

        {/* Testimonials — sin carrusel, scroll natural */}
        <div className="max-w-6xl mx-auto" data-id="element-247">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-248">
            {visible.map((t, i) => <TestimonialCard key={i} t={t} index={i} data-id="element-249" />)}
          </div>

          <AnimatePresence initial={false} data-id="element-250">
            {expanded && <motion.div key="hidden-testimonials" initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.28,
            ease: 'easeOut'
          }} className="overflow-hidden" data-id="element-251">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8" data-id="element-252">
                  {hidden.map((t, i) => <TestimonialCard key={i} t={t} index={i} data-id="element-253" />)}
                </div>
              </motion.div>}
          </AnimatePresence>

          <div className="mt-10 flex justify-center" data-id="element-254">
            <button type="button" onClick={() => setExpanded(v => !v)} aria-expanded={expanded} className="group inline-flex items-center gap-2 font-body uppercase tracking-[0.18em] text-[13px] text-[#C8A870] hover:text-[#E8D5B0] transition-colors duration-300 focus:outline-none" data-id="element-255">
              {expanded ? 'Ver menos experiencias' : 'Ver más experiencias'}
              <motion.span animate={{
              rotate: expanded ? 180 : 0
            }} transition={{
              duration: 0.28,
              ease: 'easeOut'
            }} className="inline-flex" data-id="element-256">
                <ChevronDownIcon className="w-4 h-4" data-id="element-257" />
              </motion.span>
            </button>
          </div>
        </div>
      </div>
    </section>;
}